<template>
    <div class="modal fade" id="Itemgroup" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
         aria-hidden="true">
        <div class="modal-dialog " role="document">
            <div class="modal-content">
                <div class="modal-header" style="border-bottom: unset">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">

                        <div class="col-md-7 col-12 pl-md-5 pr-md-5">
                            <div class="row">
                                <div class="col-md-12 mb-3">
                                    <h5 class="text-uppercase">Create new event</h5>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label class="mb-3">Created by:</label><br>
                                        <div class="row ml-2">
                                            <div class="col-lg-12">
                                                <input class="form-check-input ml-1 mt-1" type="checkbox" value="">
                                                <label class="ml-4">Your member name</label>
                                            </div>
                                        </div>
                                        <label class="mt-2 mb-3 ml-4">Or one of your committees (if any)</label><br>
                                        <div class="row ml-2">
                                            <div class="col-lg-6">
                                                <input class="form-check-input ml-1 mt-1" type="checkbox" value="">
                                                <label class="ml-4">Committeename</label>
                                            </div>
                                            <div class="col-lg-6">
                                                <input class="form-check-input ml-1 mt-1" type="checkbox" value="">
                                                <label class="ml-4">Committeename</label>

                                            </div>
                                            <div class="col-lg-6">
                                                <input class="form-check-input ml-1 mt-1" type="checkbox" value="">
                                                <label class="ml-4">Lorem ipsum</label>
                                            </div>
                                            <div class="col-lg-6">
                                                <input class="form-check-input ml-1 mt-1" type="checkbox" value="">
                                                <label class="ml-4">Lorem ipsum</label>

                                            </div>
                                        </div>


                                    </div>

                                </div>


                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="name">Name</label>
                                        <input type="text" class="form-control" id="name">
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="contact_remarks">Description:</label>
                                        <editor
                                                id="contact_remarks"

                                                :init="{
								height: 200,
								menubar: false,
                                language:'nl',
								plugins: [
									'advlist autolink lists link image charmap print preview anchor',
									'searchreplace visualblocks code fullscreen',
									'insertdatetime media table paste code help wordcount'
								],
								toolbar:
									'undo redo | formatselect | bold italic backcolor | \
									alignleft aligncenter alignright alignjustify | \
									bullist numlist outdent indent | removeformat | help'
							}"
                                        />
                                    </div>
                                </div>


                                <div class="col-md-12">

                                    <datepicker :label="'From'" ></datepicker>


                                    <datepicker :label="'From'" ></datepicker>
                                </div>


                            </div>
                        </div>
                        <div class="col-md-5 col-12 pl-md-2 pr-md-5">
                            <div class="row">

                                <div class="col-md-12 col-12 mb-3 p-0">
                                    Related committees if proceeds:
                                </div>
                                <div class="col-md-12 col-12 pl-md-5 pt-4 pb-4 container-bg">
                                    <div class="row">
                                        <div class="col-md-10 custom-scrollbar" style="height: 200px;">
                                            <div class="form-check  ">
                                                <input class="form-check-input" type="checkbox" value=""
                                                       id="defaultCheck1">
                                                <label class="form-check-label" for="defaultCheck1">
                                                    Default checkbox
                                                </label>
                                            </div>
                                            <div class="form-check pt-3 ">
                                                <input class="form-check-input" type="checkbox" value=""
                                                       id="defaultCheck1">
                                                <label class="form-check-label" for="defaultCheck1">
                                                    Default checkbox
                                                </label>
                                            </div>

                                        </div>
                                    </div>


                                </div>
                            </div>

                            <div class="row">

                                <div class="col-md-12 col-12 mb-3 mt-3 p-0">
                                    Related member if proceeds:
                                </div>
                                <div class="col-md-12 col-12 pl-md-5 pt-4 pb-4 container-bg">
                                    <div class="row">
                                        <div class="col-md-10 custom-scrollbar" style="height: 200px;">
                                            <div class="form-check  ">
                                                <input class="form-check-input" type="checkbox" value=""
                                                       id="defaultCheck1">
                                                <label class="form-check-label" for="defaultCheck1">
                                                    Default checkbox
                                                </label>
                                            </div>
                                            <div class="form-check pt-3 ">
                                                <input class="form-check-input" type="checkbox" value=""
                                                       id="defaultCheck1">
                                                <label class="form-check-label" for="defaultCheck1">
                                                    Default checkbox
                                                </label>
                                            </div>

                                        </div>
                                    </div>


                                </div>
                            </div>

                        </div>


                    </div>

                    <div class="row">
                        <div class="col-lg-12">
                            <button class="btn-dark float-right mt-3">Done</button>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import datepicker from "../../profile/pages/datepicker";
    export default {
        name: "createCommunity",
        components:{
            datepicker
        }
    }
</script>

<style scoped>
    @media (min-width: 576px) {
        .modal-dialog {
            max-width: 900px;
            margin: 1.75rem auto;
            margin-top: 9rem;
        }

        .delete-modal {
            max-width: 600px !important;
            margin: 1.75rem auto;
        }
    }
</style>
